<template>
  <div>
    <h2 class="pt-2 mb-4">{{ $t('message.trade.unstructuredTradeModalTitle') }}</h2>
    <MobialisFormWithValidation
      @onValidate="continueForm"
      novalidate
      v-slot="{ errors }"
      v-av-analytics-form-submit="{ elementText: $t('message.common.continue') }"
    >
      <div class="row justify-content-between">
        <div class="col-sm-8">
          <div class="form-row">
            <div class="col-sm-4">
              <mobialis-text-input-with-validation
                :rules="{ required: true, min_value: 1900, max_value: new Date().getFullYear() + 1 }"
                :label="$t('message.trade.labels.year')"
                inputmode="numeric"
                v-model="year"
                vid="year"
                data-cy="year"
              ></mobialis-text-input-with-validation>
            </div>
            <div class="col-sm-8">
              <mobialis-text-input-with-validation
                :rules="{ required: true }"
                :label="$t('message.trade.labels.make')"
                v-model="make"
                vid="make"
                data-cy="make"
              ></mobialis-text-input-with-validation>
            </div>
          </div>
          <mobialis-text-input-with-validation
            :rules="{ required: true }"
            :label="$t('message.trade.labels.model')"
            v-model="model"
            vid="model"
            data-cy="model"
          ></mobialis-text-input-with-validation>
          <div class="row">
            <div class="col-sm-8">
              <mobialis-text-input-with-validation
                :rules="{ required: true }"
                :label="$t('message.trade.labels.vehicleType')"
                :helper="$t('message.trade.labels.vehicleTypeVariants')"
                v-model="type"
                vid="type"
                data-cy="type"
              ></mobialis-text-input-with-validation>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-8">
              <mobialis-text-input-with-validation
                :label="$t('message.trade.labels.vehicleMileage')"
                :helper="$t('message.trade.labels.vehicleMileageExample')"
                v-model="mileage"
                inputmode="numeric"
                vid="mileage"
                :mask-type="languageCode === 'fr-CA' ? 'frenchInt' : 'int'"
                data-cy="mileage"
              ></mobialis-text-input-with-validation>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-10">
              <mobialis-textarea
                rows="3"
                maxlength="255"
                vid="additionalDetails"
                v-model="additionalDetails"
                data-cy="additionalDetails"
                :label="$t('message.trade.labels.additionalDetails')"
              />
            </div>
          </div>
        </div>
      </div>
      <mobialis-button type="submit" class="mt-4 mb-1" data-cy="continue"
        >{{ $t('message.common.continue') }}
      </mobialis-button>
    </MobialisFormWithValidation>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import log from '@/services/log';

export default {
  name: 'VehicleDetails',
  data() {
    return {
      year: '',
      make: '',
      model: '',
      mileage: null,
      type: '',
      additionalDetails: '',
    };
  },
  mounted() {
    this.year = this.$store.state.trade.vehicle.year;
    this.make = this.$store.state.trade.vehicle.make;
    this.model = this.$store.state.trade.vehicle.model;
    this.mileage = this.$store.state.trade.vehicle.mileage;
    this.type = this.$store.state.trade.vehicle.type;
    this.additionalDetails = this.$store.state.trade.vehicle.additionalDetails;
  },
  computed: {
    ...mapGetters({
      languageCode: 'user/getLanguageCodeForNumericalInternationalization',
    }),
  },
  methods: {
    async continueForm(isValid) {
      if (!isValid) {
        return;
      }
      try {
        this.$store.commit('SET_LOADING', true);
        this.$store.commit('trade/SET_VEHICLE_YEAR', this.year);
        this.$store.commit('trade/SET_VEHICLE_MAKE', this.make);
        this.$store.commit('trade/SET_VEHICLE_MODEL', this.model);
        this.$store.commit('trade/SET_VEHICLE_MILEAGE', this.mileage);
        this.$store.commit('trade/SET_VEHICLE_TYPE', this.type);
        this.$store.commit('trade/SET_VEHICLE_ADDITIONAL_DETAILS', this.additionalDetails);
        this.navigateToPersonalInfo();
      } catch (error) {
        log('Error in Trade Data: ', error);
        this.$router.push({ name: `trade-in-error-${this.baseRoute}` });
      } finally {
        this.$store.commit('SET_LOADING', false);
      }
    },
    navigateToPersonalInfo() {
      this.$router.push({ name: `personal-info-${this.baseRoute}` });
    },
  },
};
</script>
